var t={CloseButton:"CloseButton__CloseButton-JzM"};export{t as default};
